// extracted by mini-css-extract-plugin
module.exports = {"root":"successflash_root__ItZrQ","text_div":"successflash_text_div__t4JIm","close_text":"successflash_close_text__z4d9C"};